import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { COLORS } from "../constants";

function ResourceDetailInfo({ item }) {
  return (
    <>
      <Typography component="span" variant="caption">
        <Typography component="span" variant="caption" sx={{ color: COLORS.muted }}>Program:</Typography>{" "}
        <Typography component="span" variant="caption" sx={{ color: COLORS.body, fontWeight: 500 }}>{item.program}</Typography>
      </Typography>
      <Typography component="span" variant="caption" sx={{ color: COLORS.border }}>·</Typography>
      <Typography component="span" variant="caption">
        <Typography component="span" variant="caption" sx={{ color: COLORS.muted }}>Pathways:</Typography>{" "}
        <Typography component="span" variant="caption" sx={{ color: COLORS.body, fontWeight: 500 }}>{item.hidden ? "Hidden" : "Visible"}</Typography>
      </Typography>
    </>
  );
}

ResourceDetailInfo.propTypes = {
  item: PropTypes.shape({
    program: PropTypes.string,
    hidden: PropTypes.bool,
  }).isRequired,
};

export default ResourceDetailInfo;
